
class Cache {
  constructor(storage) {
    this.storage = storage
  }
  formatKey(key) {
    return "xn-" + key
  }
  save(key, params) {
    this.storage.setItem(this.formatKey(key), JSON.stringify(params))
  }
  get(key) {
    let value = this.storage.getItem(this.formatKey(key))
    if (value) {
      return JSON.parse(value)
    }
    return null
  }
  remove(key){
    this.storage.removeItem(this.formatKey(key));
  }
}

(function () {
  window.session = new Cache(window.sessionStorage)
  window.local = new Cache(window.localStorage)
})();


